module.exports = __webpack_public_path__ + "img/zaun2.6b2a28e4.png";